import { Create, CreateProps, SimpleForm } from 'react-admin';

import { useCreateProps, useRbacCreate } from '@hooks';
import { Forbidden, InitialPage } from '@components';
import { FinanceActivationForm, validate } from './FinanceActivationForm';

export const FinanceActivationCreate = (props: CreateProps) => {
  const createProps = useCreateProps();
  const rbacCreate = useRbacCreate();

  if (!rbacCreate) {
    return <Forbidden />;
  }

  return (
    <Create {...props} {...createProps} title="Create Activation">
      <InitialPage
        title="Activation"
        backTo="/finance-activation"
        backText="Back to all Activations"
      >
        <SimpleForm validate={validate}>
          <FinanceActivationForm />
        </SimpleForm>
      </InitialPage>
    </Create>
  );
};
